module.exports = __webpack_public_path__ + "static/OR6s-c5605fcf0aa416a13bd379f28ac939c0.jpg";